import { actionsEnum, entityTypes } from 'pages/store/actions/defaults';
import { produce } from 'immer';

const entitiesInitialState = {};
const byIdInitialState = [];
const metaInitialState = {
  [entityTypes.SINGLE]: {},
  [entityTypes.LIST]: {},
};
const linksInitialState = {
  [entityTypes.SINGLE]: {},
  [entityTypes.LIST]: {},
};
const processingInitialState = {
  [entityTypes.SINGLE]: {},
  [entityTypes.LIST]: {},
};
/* eslint-disable no-param-reassign */
export const entitiesReducer = entity => (state = entitiesInitialState, action) => {
  const { entity: actionEntity, clearEntities = [] } = action;

  if (entity !== actionEntity && clearEntities.indexOf(entity) === -1) {
    return state;
  }

  return produce(state, draft => {
    const { data = {}, id } = action;
    const { entities = {} } = data;

    switch (action.type) {
      case actionsEnum.DATA_GET_SUCCESS:
        if (entities[entity]) {
          Object.keys(entities[entity]).forEach(key => {
            draft[key] = entities[entity][key];
          });
        }
        break;
      case actionsEnum.DATA_PUT_SUCCESS:
        if (entities[entity]) {
          Object.keys(entities[entity]).forEach(key => {
            draft[key] = entities[entity][key];
          });
        }
        break;
      case actionsEnum.DATA_POST_SUCCESS:
        if (entities[entity]) {
          Object.keys(entities[entity]).forEach(key => {
            draft[key] = entities[entity][key];
          });
        }
        break;
      case actionsEnum.DATA_DELETE_SUCCESS:
        if (id in draft) {
          delete draft[id];
        }
        break;
      case actionsEnum.DATA_CLEAR:
        return entitiesInitialState;
      default:
    }
    return draft;
  });
};

export const byIdReducer = entity => (state = byIdInitialState, action) => {
  const { entity: actionEntity, clearEntities = [] } = action;

  if (entity !== actionEntity && clearEntities.indexOf(entity) === -1) {
    return state;
  }

  return produce(state, draft => {
    const { data = {} } = action;

    switch (action.type) {
      case actionsEnum.DATA_GET_SUCCESS:
        if (!Array.isArray(data.result)) {
          if (draft.indexOf(data.result) === -1) {
            draft.push(data.result);
          }
        } else {
          return data.result;
        }
        break;
      case actionsEnum.DATA_PUT_SUCCESS:
        if (!Array.isArray(data.result)) {
          if (draft.indexOf(data.result) === -1) {
            draft.push(data.result);
          }
        } else {
          return data.result;
        }
        break;
      case actionsEnum.DATA_POST_SUCCESS:
        if (!Array.isArray(data.result)) {
          if (draft.indexOf(data.result) === -1) {
            draft.push(data.result);
          }
        } else {
          return data.result;
        }
        break;
      case actionsEnum.DATA_DELETE_SUCCESS: {
        const indexOfEntity = draft.indexOf(action.id);
        if (indexOfEntity !== -1) {
          draft.splice(indexOfEntity, 1);
        }
        break;
      }
      case actionsEnum.DATA_CLEAR:
        return byIdInitialState;
      default:
    }
    return draft;
  });
};

export const metaReducer = entity => (state = metaInitialState, action) => {
  const { entity: actionEntity, clearEntities = [] } = action;

  if (entity !== actionEntity && clearEntities.indexOf(entity) === -1) {
    return state;
  }

  return produce(state, draft => {
    const { list, meta } = action;
    const type = list ? entityTypes.LIST : entityTypes.SINGLE;

    switch (action.type) {
      case actionsEnum.DATA_GET_SUCCESS:
        draft[type] = meta;
        break;
      case actionsEnum.DATA_POST_SUCCESS:
        draft[type] = meta;
        break;
      case actionsEnum.DATA_PUT_SUCCESS:
        draft[type] = meta;
        break;
      case actionsEnum.DATA_CLEAR:
        return metaInitialState;
      default:
    }
    return draft;
  });
};

export const linksReducer = entity => (state = linksInitialState, action) => {
  const { entity: actionEntity, clearEntities = [] } = action;

  if (entity !== actionEntity && clearEntities.indexOf(entity) === -1) {
    return state;
  }

  return produce(state, draft => {
    const { list, links } = action;
    const type = list ? entityTypes.LIST : entityTypes.SINGLE;

    switch (action.type) {
      case actionsEnum.DATA_GET_SUCCESS:
        draft[type] = links;
        break;
      case actionsEnum.DATA_POST_SUCCESS:
        draft[type] = links;
        break;
      case actionsEnum.DATA_PUT_SUCCESS:
        draft[type] = links;
        break;
      case actionsEnum.DATA_CLEAR:
        return linksInitialState;
      default:
    }
    return draft;
  });
};

export const processingReducer = entity => (state = processingInitialState, action) => {
  const { entity: actionEntity, clearEntities = [] } = action;

  if (entity !== actionEntity && clearEntities.indexOf(entity) === -1) {
    return state;
  }

  return produce(state, draft => {
    const { list, actionType, status, errors, cancelToken } = action;
    const type = list ? entityTypes.LIST : entityTypes.SINGLE;

    switch (action.type) {
      case actionsEnum.DATA_PROCESSING:
        draft[type] = {
          [actionType]: {
            status,
            errors,
            cancelToken,
          },
        };
        break;
      case actionsEnum.DATA_CLEAR:
      case actionsEnum.ERROR_CLEAR:
        return processingInitialState;
      default:
    }
    return draft;
  });
};
/* eslint-enable no-param-reassign */
